import { render } from "./AppConfig.vue?vue&type=template&id=aaf1eff8&scoped=true&ts=true"
import script from "./AppConfig.vue?vue&type=script&lang=ts"
export * from "./AppConfig.vue?vue&type=script&lang=ts"

import "./AppConfig.vue?vue&type=style&index=0&id=aaf1eff8&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaf1eff8"]])

export default __exports__